/**
 * Tooltip positioning mapping
 * @type {{LEFT: string, TOP: string, RIGHT: string, BOTTOM: string}}
 */
export const TooltipPositionings = {
  LEFT: 'left',
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom'
};

export const CREATE_ISSUE_FORM_LOCAL_STORAGE_KEY = 'createIssueFormKey';
export const CREATE_TEMPLATE_FORM_LOCAL_STORAGE_KEY = 'createTemplateFormKey';

export const TIME_UNIT = {
  MINUTE: 60000,
  SECOND: 1000
};
